import { render, staticRenderFns } from "./constructionRelactionTaskRiskAssess.vue?vue&type=template&id=3afda2d6"
import script from "./constructionRelactionTaskRiskAssess.vue?vue&type=script&lang=js"
export * from "./constructionRelactionTaskRiskAssess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3afda2d6')) {
      api.createRecord('3afda2d6', component.options)
    } else {
      api.reload('3afda2d6', component.options)
    }
    module.hot.accept("./constructionRelactionTaskRiskAssess.vue?vue&type=template&id=3afda2d6", function () {
      api.rerender('3afda2d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/scm/constructionRelactionTaskRiskAssess.vue"
export default component.exports